import { cn } from '@/lib/utils';
import * as React from 'react';

interface TooltipProps {
  children: React.ReactNode;
  content: string;
  className?: string;
}

export function Tooltip({ children, content, className }: TooltipProps) {
  const [isVisible, setIsVisible] = React.useState(false);

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div
          className={cn(
            'absolute z-50 px-2 py-1 text-xs font-medium text-white bg-gray-900 dark:bg-gray-100 dark:text-gray-900 rounded-md shadow-lg pointer-events-none whitespace-nowrap',
            'bottom-full left-1/2 -translate-x-1/2 mb-1.5',
            'after:content-[""] after:absolute after:top-full after:left-1/2 after:-translate-x-1/2',
            'after:border-4 after:border-transparent after:border-t-gray-900 dark:after:border-t-gray-100',
            className
          )}
          style={{ marginBottom: '0.375rem' }}
        >
          {content}
        </div>
      )}
    </div>
  );
}
